import { render } from "./OurCta.vue?vue&type=template&id=3548667b"
import script from "./OurCta.vue?vue&type=script&lang=js"
export * from "./OurCta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__